var map = {
	"./cnn-money-x2.png": 2069,
	"./economist-x2.png": 2070,
	"./mashable-x2.png": 2071,
	"./tech-crunch-x2.png": 2072,
	"./thenewyorker-x2.png": 2073,
	"./thrillist-x2.png": 2074,
	"./time-x2.png": 2075,
	"./usa-today-x2.png": 2076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2291;